export default "__VITE_ASSET__BvAZD8_V__"